import React from 'react';
import PropTypes from 'prop-types';

export const ChartLegend = ({ children }) => {
    return (
        <div
            className="d-flex helix-flex--column mr-2">
            {children}
        </div>
    );
};

ChartLegend.propTypes = {
    children: PropTypes.element
};
